import React from 'react';
export function Favicon() {
  return <svg width="512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style={{
    display: 'block'
  }} data-id="element-158">
      {/* Background */}
      <rect width="512" height="512" rx="96" fill="#0a0a0a" data-id="element-159" />

      {/* Amber accent bar at bottom */}
      <rect x="80" y="408" width="352" height="24" rx="12" fill="#d4a853" data-id="element-160" />

      {/* Bold M letter */}
      <path d="M 112 376 L 112 136 L 176 136 L 256 280 L 336 136 L 400 136 L 400 376 L 344 376 L 344 232 L 280 344 L 232 344 L 168 232 L 168 376 Z" fill="#f5f5f0" data-id="element-161" />
    </svg>;
}